import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import HerobgOne from './../assets/images/hero-bg.jpg';
import HerobgTwo from './../assets/images/hero-bg-2.jpg';

const Hero = () => {
  return (
    <div className="hero hero-slider-layout">
      <Swiper
        className="swiper"
        slidesPerView={1}
        speed={1000}
        spaceBetween={0}
        loop={true}
        autoplay={{ delay: 4000 }}
        pagination={{  el: '.hero-pagination', clickable: true }}
        modules={[Autoplay, Pagination]}
        onBeforeInit={(swiper) => {
          // force Swiper to look for pagination element manually
          swiper.params.pagination.el = '.hero-pagination';
        }}
      >
        {/* Slide 1 */}
        <SwiperSlide>
          <div className="hero-slide">
            <div className="hero-slider-image">
              <img src={HerobgOne} alt="Hero Background 1" />
            </div>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-10">
                  <div className="hero-content">
                    <div className="section-title">
                      <h3 className="wow fadeInUp">inspired interiors</h3>
                      <h1 className="text-anime-style-2" data-cursor="-opaque">
                        Designing your dream spaces, one room at a time
                      </h1>
                      <p className="wow fadeInUp" data-wow-delay="0.2s">
                        We specialize in creating personalized, functional, and
                        stylish interiors that reflect your unique vision.
                      </p>
                    </div>
                    {/* <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                      <a href="/about-" className="btn-default">
                        explore more
                      </a>
                      <a href="projects.html" className="btn-default btn-highlighted">
                        view projects
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 2 */}
        <SwiperSlide>
          <div className="hero-slide">
            <div className="hero-slider-image">
              <img src={HerobgTwo} alt="Hero Background 2" />
            </div>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-10">
                  <div className="hero-content">
                    <div className="section-title">
                      <h3 className="wow fadeInUp">inspired interiors</h3>
                      <h1 className="text-anime-style-2" data-cursor="-opaque">
                        Designing your dream spaces, one room at a time
                      </h1>
                      <p className="wow fadeInUp" data-wow-delay="0.2s">
                        We specialize in creating personalized, functional, and
                        stylish interiors that reflect your unique vision.
                      </p>
                    </div>
                    {/* <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                      <a href="about.html" className="btn-default">
                        explore more
                      </a>
                      <a href="projects.html" className="btn-default btn-highlighted">
                        view projects
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Hero;
